import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Body, Box, Button } from '@iclinic/design-system';
import Turnstile from 'react-turnstile';

import {
  professionalCountSelector,
  isDoctorSelector,
  statusSelector,
  professionSelector,
} from '../state/selectors';
import * as S from './ChipSelectorContainers.styles';
import { TurnstileContainer } from './InputStep.styles';
import { RequestStatus } from 'shared/constants/State';
import {
  backStep,
  setProfessionalCount,
  setTurnstileToken,
  submitProfessionalCount,
} from '../state/reducer';
import { Profession, ProfessionalCount, SignupSteps } from '../state/types';
import { ButtonSubmit } from '../components/Signup.styles';
import { Actions } from '../components/Actions/Actions';
import { useCheckStep } from '../hooks/useCheckStep';
import { trackSignupStep } from '../trackSignupUtils';
import { trackingStepNames } from '../constants';

const ProfessionalCountStepContainer = () => {
  const dispatch = useDispatch();
  const status = useSelector(statusSelector);
  const profession = useSelector(professionSelector);
  const isDoctor = useSelector(isDoctorSelector);
  const professionalCount = useSelector(professionalCountSelector);
  const isDisabled = !professionalCount;
  useCheckStep({ navigationStep: SignupSteps.ProfessionCount });

  const handleSubmit = () => {
    if (professionalCount) {
      dispatch(submitProfessionalCount(professionalCount));
    }
  };

  const handleBackStep = () => {
    trackSignupStep({
      name: trackingStepNames[SignupSteps.Job].back,
    });
    dispatch(backStep(SignupSteps.Job));
  };

  const handleChipSelection = (
    selectedProfessionalCount: ProfessionalCount,
  ) => {
    trackSignupStep({
      name: 'user_professionals_quantity',
      stepValue: selectedProfessionalCount,
    });

    dispatch(setProfessionalCount(selectedProfessionalCount));
  };
  const lastStepProfessions: Profession[] = [
    Profession.Receptionist,
    Profession.ClinicAdmin,
    Profession.BusinessITConsultant,
  ];

  const lastStepVerification =
    profession !== undefined && lastStepProfessions.includes(profession);
  const nextButtonMessage = lastStepVerification ? 'Iniciar' : 'Avançar';

  return (
    <Box>
      <S.StepHeading variant="md">
        Quantos profissionais da saúde trabalham na clínica?
      </S.StepHeading>
      <Body variant="xs">
        Queremos entender mais sobre o momento de sua carreira para melhor lhe
        ajudar.
      </Body>
      <S.ChipsContainer>
        {Object.values(ProfessionalCount).map((count) => (
          <S.Chip
            key={count}
            label={isDoctor && count && count === '1' ? 'Apenas eu' : count}
            active={professionalCount === count}
            variant="outlined"
            onClick={() => handleChipSelection(count)}
          />
        ))}
        {lastStepVerification && (
          <TurnstileContainer>
            <Turnstile
              sitekey={process.env.CF_TURNSTILE_SIGNUP_KEY ?? ''}
              onVerify={(token) => dispatch(setTurnstileToken(token))}
              retryInterval={1000}
              theme="light"
              refreshExpired="auto"
              appearance="interaction-only"
              execution="render"
            />
          </TurnstileContainer>
        )}
      </S.ChipsContainer>
      <Actions>
        <Button
          variant="contained"
          color="transparent"
          size="medium"
          onClick={handleBackStep}
        >
          Voltar
        </Button>
        <ButtonSubmit
          color="primary"
          disabled={isDisabled}
          size="large"
          variant="contained"
          onClick={handleSubmit}
          isLoading={status === RequestStatus.Pending}
        >
          {nextButtonMessage}
        </ButtonSubmit>
      </Actions>
    </Box>
  );
};

export default ProfessionalCountStepContainer;
